//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    title: String,
    isRed: {
      type: Boolean,
      default: false
    },
    documentId: String,
    catId: String,
    range: Array,
    linkName: String
  },
  computed: {
    prevSlug () {
      const index = this.range.findIndex(el => el.documentId === this.documentId)

      if (index <= 0) {
        return null
      } else {
        return this.range[index - 1].name
      }
    },
    nextSlug () {
      const index = this.range.findIndex(el => el.documentId === this.documentId)

      if (index < 0 || index === this.range.length - 1) {
        return null
      } else {
        return this.range[index + 1].name
      }
    },
    canIncrement () {
      return this.nextSlug
    },
    canDecrement () {
      return this.prevSlug
    }
  }
}

